// extracted by mini-css-extract-plugin
export var askAiIcon = "_lq-j";
export var category = "_lq-9";
export var categoryHeader = "_lq-e";
export var container = "_lq-0";
export var group = "_lq-a";
export var groupItems = "_lq-f";
export var groupSeparator = "_lq-k";
export var loading = "_lq-1";
export var noResults = "_lq-3";
export var placeholder = "_lq-2";
export var resultContent = "_lq-5";
export var resultIcon = "_lq-c";
export var resultItem = "_lq-g";
export var resultMeta = "_lq-8";
export var resultSubtitle = "_lq-7";
export var resultSuffix = "_lq-i";
export var resultTitle = "_lq-6";
export var resultsList = "_lq-4";
export var searchGroup = "_lq-d";
export var selected = "_lq-h";
export var subgroup = "_lq-b";